import { MobilePageHeader, type MobilePageHeaderProps } from './MobilePageHeader';

export interface ResponsivePageHeaderProps {
  /** Props for the mobile-only header (hamburger, title, count, search toggle) */
  mobile: Omit<MobilePageHeaderProps, 'className'>;
  /** Desktop-only header content (total label + centered search + spacer) */
  children?: React.ReactNode;
}

/**
 * Standardised responsive page header.
 * 
 * Renders:
 * - Mobile (< md): MobilePageHeader with hamburger + title + count + search
 * - Desktop (>= md): the provided children (usually the balanced total/search/total layout)
 *
 * Usage (standardised dry pattern):
 *   <Page.Header className="py-6 md:py-0">
 *     <ResponsivePageHeader mobile={{ title, count, searchValue, onSearchChange, ... }}>
 *       <div className="shrink-0"> <PageHeaderTotalLabel ... /> </div>
 *       <div className="flex-1 ..."> <PageHeaderSearchBar ... /> </div>
 *       <div className="min-w-0 invisible"> ... </div>
 *     </ResponsivePageHeader>
 *   </Page.Header>
 */
export function ResponsivePageHeader({ mobile, children }: ResponsivePageHeaderProps) {
  return (
    <>
      <MobilePageHeader className="md:hidden px-6" {...mobile} />
      <div className="hidden md:flex items-center w-full px-6 sm:px-8 lg:px-16 gap-4">
        {children}
      </div>
    </>
  );
}
